import { ProgramModel } from "./ProgramContext";

export abstract class Instruction<T extends string = string> {
  abstract readonly type: T;

  abstract act(context: ProgramModel): { shouldAdvanceCursor?: boolean } | void;

  toString(): string {
    return this.type;
  }

  isType(type: string): boolean {
    return this.type === type;
  }
}
